import { getCurrentSession } from '../../lib/authentication';

const getWithHeader = async (id, method) => {
  await getCurrentSession()
  const { accessToken } = await getCurrentSession()

  return apigClient[method](
    { id },
    {},
    {
      headers: {
        Authorization: accessToken
      }
    }
  );
}

export const getUnderWriter = (id) => getWithHeader(id, 'adminUsersIdGet');

export const getBroker = (id) => getWithHeader(id, 'apiGetBrokerIdGet');
